import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type Props = {
	label: string;
	htmlFor: string;
	hint?: string;
	error?: string;
};

export const StackedField: FC<PropsWithChildren<Props>> = ({
	label,
	htmlFor,
	hint,
	error,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack>
			<Typography
				component="label"
				htmlFor={htmlFor}
				variant="bodyMedium"
				color={error ? theme.palette.error.main : theme.palette.grey[700]}
				mb={theme.spacingTokens.xs}
			>
				{label}
			</Typography>
			{children}
			{error && (
				<Typography
					variant="caption"
					color={theme.palette.error.main}
					display="block"
					mt={theme.spacingTokens.xs}
				>
					{error}
				</Typography>
			)}
			{hint && (
				<Typography variant="hint" display="block" mt={theme.spacingTokens.xs}>
					{hint}
				</Typography>
			)}
		</Stack>
	);
};
